export default "__VITE_ASSET__DhsVTax8__"